import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { environment } from '../../../environments/environment';
import { User } from '../../models/cube';
import { SyncService } from '../../services/sync/sync.service';
import { SyncStatus } from '../../shared/configs/sync-status.config';
import { selectUserDetails } from '../../store/selectors/auth.selectors';

import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cube-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: false,
})
export class ToolbarComponent implements OnInit, OnDestroy {
  @Output() onDepartmentClick: EventEmitter<any> = new EventEmitter<any>();

  @Input() sidenav;
  @Input() sidebar;
  @Input() drawer;
  @Input() matDrawerShow;

  currentUser?: Observable<User> = null;
  isSettingPanelEnabled = false;
  isSupportToolEnabled = true;
  isSyncInProgress: boolean = false;
  searchOpen = false;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private store: Store, private syncService: SyncService) {}

  ngOnInit(): void {
    // TEMP: For B2C migration
    // INFO get user details from store
    this.currentUser = this.store.select(selectUserDetails);
    this.setEventListeners();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onAction(action: any): void {}

  onSearch(search: any): void {}

  openSupportPage(): void {
    window.open(environment.supportUrl, '_blank');
  }

  private setEventListeners(): void {
    // SyncingInspection
    this.syncService
      .getSyncingInspection$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((syncingInspection) => {
        this.isSyncInProgress =
          syncingInspection != null &&
          ![
            SyncStatus.cancelled,
            SyncStatus.completed,
            SyncStatus.failed,
          ].includes(syncingInspection.syncStatus);
      });
  }
}
